import {
  saveStorePart,
  loadStorePart,
  cleanStorePart,
} from 'utils/LocalStorageUtil';
import { handleActions, combineActions } from 'redux-actions';
import { LOAD_PROFILES, UPDATE_PROFILE } from '../constants';

const initialState = {
  error: false,
  loading: false,
  data: loadStorePart('profiles'),
  response: null,
};

const profileReducer = handleActions(
  {
    [LOAD_PROFILES.PENDING]: state => ({
      ...state,
      loading: false,
    }),
    [combineActions(
      LOAD_PROFILES.CANCELLED,
      LOAD_PROFILES.SUCCESS,
      LOAD_PROFILES.ERROR,
    )]: state => ({
      ...state,
      loading: false,
    }),
    [LOAD_PROFILES.ERROR]: (state, { payload }) => {
      cleanStorePart('profiles');
      return {
        ...state,
        error: true,
        data: null,
        response: payload,
      };
    },
    [UPDATE_PROFILE.SUCCESS]: (state, { payload }) => {
      const data = { ...state.data };
      const memberUpdated = payload;
      delete memberUpdated.lasttouch;
      const memberIndex = data.members.findIndex(
        m => m.gamification_id === memberUpdated.gamification_id,
      );
      data.members[memberIndex] = memberUpdated;
      return { ...state, data };
    },
    [LOAD_PROFILES.SUCCESS]: (state, { payload }) => {
      saveStorePart('profiles', payload);
      return {
        ...state,
        error: false,
        data: payload,
      };
    },
    [UPDATE_PROFILE.USERNAME]: (state, { payload }) => {
      const { firstname } = payload;
      let data = Object.assign({}, state.data);
      if (data.members)
        data.members.map(e => {
          if (e.admin) e.username = firstname;
          return e;
        });
      else data = null;
      return {
        ...state,
        error: false,
        data,
      };
    },
    [LOAD_PROFILES.CLEAR]: state => ({
      ...state,
      error: false,
      response: null,
    }),
  },
  initialState,
);

export default profileReducer;
